import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  compose,
  setPropTypes,
  withState,
  withHandlers,
  lifecycle
} from 'recompose';
import { withRouter } from 'react-router';
import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import GroupDetailTable from '../../components/molecules/GroupDetailTable';
import GroupShopDetailTableHead from '../../components/molecules/GroupShopDetailTableHead';
import GroupShopDetailTableBody from '../../components/molecules/GroupShopDetailTableBody';
import TablePagination from '../../components/molecules/TablePagination';
import { getGroupDetail } from '../../actions/Groups';
import CloseButton from '../../components/atoms/CloseButton';
import { sendLogin } from '../../auth/Auth';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  margin: {
    margin: '20px 0 0 0'
  },
  scrollTable: {
    maxHeight: 296,
    overflowX: 'scroll',
    whiteSpace: 'nowrap'
  }
};

const propTypes = {
  classes: PropTypes.object.isRequired
};

const enhance = compose(
  connect(
    state => ({
      name: state.loginInfo.name,
      detail: state.groups.detail
    }),
    dispatch => ({
      actions: bindActionCreators({ getGroupDetail }, dispatch)
    })
  ),
  setPropTypes(propTypes),
  withState('groupShopPage', 'setGroupShopPage', 0),
  withState('groupShopRowsPerPage', 'setGroupShopRowsPerPage', 5),
  withState('followPage', 'setFollowPage', 0),
  withState('followRowsPerPage', 'setFollowRowsPerPage', 5),
  withState('followerPage', 'setFollowerPage', 0),
  withState('followerRowsPerPage', 'setFollowerRowsPerPage', 5),
  withState('order', 'setOrder', 'asc'),
  withState('orderBy', 'setOrderBy', 'groupShopId'),
  withHandlers({
    checkSession: props => data => {
      if (data.error === true && data.payload.status === 403) {
        sendLogin(props);
      }
      return data;
    },
    handleChangeGroupShopPage: props => (event, groupShopPage) => {
      props.setGroupShopPage(groupShopPage);
    },
    handleChangeGroupShopRowsPerPage: props => event => {
      props.setGroupShopRowsPerPage(event.target.value);
    },
    handleChangeFollowPage: props => (event, followPage) => {
      props.setFollowPage(followPage);
    },
    handleChangeFollowRowsPerPage: props => event => {
      props.setFollowRowsPerPage(event.target.value);
    },
    handleChangeFollowerPage: props => (event, followerPage) => {
      props.setFollowerPage(followerPage);
    },
    handleChangeFollowerRowsPerPage: props => event => {
      props.setFollowerRowsPerPage(event.target.value);
    },
    handleRequestSort: props => property => {
      const isDesc = props.orderBy === property && props.order === 'desc';
      props.setOrder(isDesc ? 'asc' : 'desc');
      props.setOrderBy(property);
    }
  }),
  lifecycle({
    componentDidMount() {
      this.props.actions
        .getGroupDetail(this.props.targetRowId)
        .then(data => this.props.checkSession(data));
    }
  })
);

const Main = enhance(
  ({
    classes,
    detail,
    updateOpenDetailModal,
    groupShopPage,
    groupShopRowsPerPage,
    order,
    orderBy,
    handleChangeGroupShopPage,
    handleChangeGroupShopRowsPerPage,
    handleRequestSort
  }) => {
    const groupShopEmptyRows =
      groupShopRowsPerPage -
      Math.min(
        groupShopRowsPerPage,
        detail.groupShops
          ? detail.groupShops.length
          : 0 - groupShopPage * groupShopRowsPerPage
      );
    const closeAction = () => updateOpenDetailModal(false);
    return (
      <div className={classes.root}>
        <Typography variant="h6">グループ運営会社情報詳細</Typography>
        <div>
          <GroupDetailTable
            groupName={detail.groupName}
            zipCode={detail.zipCode}
            prefectures={detail.prefectures}
            city={detail.city}
            address={detail.address}
            building={detail.building}
            phone={detail.phone}
            fax={detail.fax}
            email={detail.email}
            createdAt={detail.createdAt}
            updatedAt={detail.updatedAt}
          />
        </div>
        <div className={classes.margin}>
          <div>グループ店舗</div>
          <div className={classes.scrollTable}>
            <Table stickyHeader>
              <GroupShopDetailTableHead
                order={order}
                orderBy={orderBy}
                onRequestSort={handleRequestSort}
              />
              <GroupShopDetailTableBody
                groupShops={detail.groupShops}
                emptyRows={groupShopEmptyRows}
                page={groupShopPage}
                rowsPerPage={groupShopRowsPerPage}
                order={order}
                orderBy={orderBy}
              />
            </Table>
          </div>
          <div>
            <TablePagination
              searchResults={detail.groupShops}
              page={groupShopPage}
              rowsPerPage={groupShopRowsPerPage}
              handleChangePage={handleChangeGroupShopPage}
              handleChangeRowsPerPage={handleChangeGroupShopRowsPerPage}
            />
          </div>
        </div>
        <div>
          <CloseButton onClickAction={closeAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
